import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { motion } from 'framer-motion'; 
const imagePaths = [
  '/Images/Ai1.png',
  '/Images/Ai2.png',
  '/Images/Ai3.png',
  '/Images/Ai4.png',
  '/Images/Ai5.png'
];

const BlueHeaderSection = ({ heading, url, showServices = false }) => {
  const [currentImageIndex, setCurrentImageIndex] = useState(0);

  useEffect(() => {
    const interval = setInterval(() => {
      setCurrentImageIndex((prev) => (prev + 1) % imagePaths.length);
    }, 6000);
    return () => clearInterval(interval);
  }, []);

  return (
    <section className="mt-[150px] relative min-h-[230px] md:min-h-[280px] lg:min-h-[330px] flex flex-col items-center justify-center px-4 py-12 overflow-hidden">

      {/* Background Image Slideshow */}
      <div className="absolute inset-0 z-0 transition-opacity duration-1000 ease-in-out">
        {imagePaths.map((path, index) => (
          <img
            key={index}
            src={path}
            alt={`Background ${index}`}
            className={`absolute inset-0 w-full h-full object-cover transition-opacity duration-1000 ease-in-out ${
              index === currentImageIndex ? 'opacity-100' : 'opacity-0'
            }`}
          />
        ))}
        <div className="absolute inset-0 bg-gradient-to-br from-[#1b2f5a]/80 via-[#2a4a7a]/80 to-[#1b2f5a]/80 z-10" />
      </div>

      {/* Hexagons */}
     <motion.div
  drag
  dragConstraints={{ top: -100, left: -100, right: 100, bottom: 100 }}
  dragElastic={0.5}
  className="absolute top-4 left-8 md:top-6 md:left-16 lg:top-8 lg:left-20 w-12 h-12 md:w-16 md:h-16 lg:w-20 lg:h-20 z-20 cursor-grab"
>
  <div className="hexagon-rotate-clockwise">
    <svg viewBox="0 0 100 100" className="w-full h-full">
      <polygon
        points="50,3 86.6,28 86.6,72 50,97 13.4,72 13.4,28"
        fill="none"
        stroke="#f7941d"
        strokeWidth="6"
      />
    </svg>
  </div>
</motion.div>


      <motion.div
  drag
  dragConstraints={{ top: -100, left: -100, right: 100, bottom: 100 }}
  dragElastic={0.5}
  className="absolute bottom-4 left-4 md:bottom-6 md:left-12 lg:bottom-8 lg:left-16 w-10 h-10 md:w-14 md:h-14 lg:w-18 lg:h-18 z-20 cursor-grab"
>
  <div className="hexagon-rotate-anticlockwise">
    <svg viewBox="0 0 100 100" className="w-full h-full">
      <polygon
        points="50,3 86.6,28 86.6,72 50,97 13.4,72 13.4,28"
        fill="none"
        stroke="#f7941d"
        strokeWidth="6"
      />
    </svg>
  </div>
</motion.div>


      <motion.div
  drag
  dragConstraints={{ top: -100, left: -100, right: 100, bottom: 100 }}
  dragElastic={0.5}
  className="absolute bottom-4 right-4 md:bottom-6 md:right-8 lg:bottom-8 lg:right-12 w-16 h-16 md:w-20 md:h-20 lg:w-24 lg:h-24 z-20 cursor-grab"
>
  <div className="hexagon-rotate-clockwise-delayed">
    <svg viewBox="0 0 100 100" className="w-full h-full">
      <polygon
        points="50,3 86.6,28 86.6,72 50,97 13.4,72 13.4,28"
        fill="none"
        stroke="#f7941d"
        strokeWidth="6"
      />
    </svg>
  </div>
</motion.div>


      {/* Heading */}
      <div className="relative z-30 text-center  mx-auto mb-6 md:mb-8 lg:mb-10">
        <h1 className="text-3xl md:text-4xl lg:text-5xl xl:text-6xl font-bold text-white tracking-wider">
          {heading}
        </h1>
      </div>

      {/* Breadcrumb */}
      <div className="absolute bottom-4 left-1/2 transform -translate-x-1/2 md:bottom-6 lg:bottom-8 z-30">
        <div className="inline-flex items-center justify-center bg-[#1b2f5a] border-2 border-[#f7941d] rounded-lg px-6 py-3 md:px-8 md:py-4 shadow-lg">
          <nav className="flex items-center space-x-3 text-base md:text-lg">
            <Link
              to="/"
              className="text-[#f7941d] hover:text-white transition-colors duration-300 font-medium"
            >
              Home
            </Link>
            <span className="text-[#f7941d]">/</span>
            {showServices && (
              <>
                <Link
                  to="/services"
                  className="text-[#f7941d] hover:text-white transition-colors duration-300 font-medium"
                >
                  Services
                </Link>
                <span className="text-[#f7941d]">/</span>
              </>
            )}
            <span className="text-white font-bold">{url}</span>
          </nav>
        </div>
      </div>

      {/* CSS Animations */}
      <style jsx>{`
        @keyframes rotateClockwise {
          0% { transform: rotate(0deg); }
          50% { transform: rotate(360deg); }
          100% { transform: rotate(0deg); }
        }
        @keyframes rotateAnticlockwise {
          0% { transform: rotate(0deg); }
          50% { transform: rotate(-360deg); }
          100% { transform: rotate(0deg); }
        }
        .hexagon-rotate-clockwise {
          animation: rotateClockwise 8s ease-in-out infinite;
        }
        .hexagon-rotate-anticlockwise {
          animation: rotateAnticlockwise 10s ease-in-out infinite;
        }
        .hexagon-rotate-clockwise-delayed {
          animation: rotateClockwise 12s ease-in-out infinite;
          animation-delay: 2s;
        }
      `}</style>
    </section>
  );
};

export default BlueHeaderSection;
